const ZERO_SUMMARY = Object.freeze({
  availableCents: 0,
  reservedCents: 0,
  inTransitCents: 0,
  providerPaidCents: 0,
  failedReleasedCents: 0,
  reconciliationRequiredCents: 0,
  legacyUnverifiedPayoutCents: 0,
  availableTransactionCount: 0,
  assumedCurrencyEntryCount: 0,
  totalHostsCount: 0,
});

function integerOrZero(value) {
  const numeric = Number(value);
  return Number.isSafeInteger(numeric) ? numeric : 0;
}

export function normalizeHostBalancesResponse(response) {
  const payload = response?.data || response || {};
  const hosts = Array.isArray(payload.hosts) ? payload.hosts : [];
  const rawSummary = payload.summary || {};
  const summary = Object.keys(ZERO_SUMMARY).reduce((result, key) => ({
    ...result,
    [key]: integerOrZero(rawSummary[key]),
  }), {});
  const rawPagination = payload.pagination || {};
  const totalHosts = integerOrZero(rawPagination.totalHosts) || summary.totalHostsCount;

  return {
    schemaVersion: payload.schemaVersion || 1,
    asOf: payload.asOf || null,
    currency: String(payload.currency || "usd").toLowerCase(),
    hosts,
    summary: {
      ...summary,
      platformPayoutBlocked: rawSummary.platformPayoutBlocked === true,
    },
    pagination: {
      currentPage: integerOrZero(rawPagination.currentPage) || 1,
      limit: integerOrZero(rawPagination.limit) || 10,
      totalPages: integerOrZero(rawPagination.totalPages),
      totalHosts,
    },
  };
}

export function formatCents(value, currency = "usd") {
  const cents = integerOrZero(value);
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: String(currency || "usd").toUpperCase(),
  }).format(cents / 100);
}

export function entryAmountCents(entry) {
  if (entry?.signedAmountCents !== undefined && entry?.signedAmountCents !== null) {
    const signedCents = Number(entry.signedAmountCents);
    if (Number.isSafeInteger(signedCents)) return signedCents;
  }

  if (entry?.amountCents !== undefined && entry?.amountCents !== null) {
    const amountCents = Number(entry.amountCents);
    if (Number.isSafeInteger(amountCents)) {
      const magnitude = Math.abs(amountCents);
      return entry?.transactionType === "debited" ? -magnitude : magnitude;
    }
  }

  const amount = Number(entry?.amount);
  if (!Number.isFinite(amount)) return 0;
  const cents = Math.round(Math.abs(amount) * 100);
  return entry?.transactionType === "debited" ? -cents : cents;
}

export function getHostBalanceErrorMessage(error) {
  if (typeof error === "string" && error.trim()) return error;
  return error?.response?.data?.message || error?.response?.data?.userMessage || error?.message || "Failed to fetch host payout balances.";
}
